import api from "./api"

export const createTransaction = async (data) => {
  return await api.post('/transaction/create-transaction', data);
}

export const createTransactionAdmin = async (data) => {
  return await api.post('/transaction/create-transaction-admin', data, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getTransactionActive = async () => {
  return await api.get('/transaction/get-transaction-active', {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const sendReceipt = async (id) => {
  return await api.get(`/transaction/send-receipt/${id}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getAllTransaction = async () => {
  return await api.get('/transaction/get-all-transaction', {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getAllTransactionV2 = async (page, pageSize, carName, policeNumber) => {
  let url = `/transaction/get-all-transaction-v2?page=${page}&pageSize=${pageSize}`;
  if (carName) {
    url += `&vehicleName=${encodeURIComponent(carName)}`;
  }
  if (policeNumber) {
    url += `&policeNumber=${encodeURIComponent(policeNumber)}`;
  }
  return await api.get(url, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getHistoryTransaction = async (id) => {
  return await api.get(`/transaction/get-history-transaction-user/${id}`);
}

export const updateStatusTransaction = async (id, data) => {
  return await api.patch(`/transaction/update-status-transaction/${id}`, data, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const deleteTransaction = async (id) => {
  return await api.delete(`/transaction/delete-transaction/${id}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getDescriptionTransaction = async (id) => {
  return await api.get(`/transaction/get-description/${id}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getTransactionById = async (id) => {
  return await api.get(`/transaction/get-transaction/${id}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const updateDescriptionTransaction = async (id, data) => {
  return await api.put(`/transaction/update-description/${id}`, data, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getTotalIncomeTransactionPerMonthInYear = async (year) => {
  return await api.get(`/transaction/get-total-income?year=${year}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}